module.exports = __webpack_public_path__ + "static/about_banner-98bb5b69bf3bff911fa459cc1be905d5.png";